import { Form, Input, Button, Card, message } from "antd";
import api from "../../services/api";

export default function ForgotPassword() {

  const onFinish = async (values) => {
    try {
      await api.post("/auth/forgot-password", values);
      message.success("Reset link sent to your email");
    } catch (err) {
      message.error(
        err.response?.data?.message || "Something went wrong"
      );
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 80 }}>
      <Card title="Forgot Password" style={{ width: 400 }}>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="email"
            label="Registered Email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Send Reset Link
          </Button>
        </Form>
      </Card>
    </div>
  );
}